(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-vendor-yandex"] = factory(require("mggp-player"));
	else
		root["mggp-vendor-yandex"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return 